// Which backend build is live: GET /version/ returns its git commit (see backend api/backend_version.py).
import axios from "axios";
import { API_PATH } from "../constants/ApiPath";

let pending = null;

// The live backend commit, fetched once per page load; "" when the backend can't be reached.
export function fetchBackendVersion() {
  if (!pending) {
    pending = axios
      .get(API_PATH.concat("/version/"), { timeout: 10000 })
      .then((res) => (res && res.data && res.data.commit) || "")
      .catch(() => "");
  }
  return pending;
}

export function resetBackendVersionCache() {
  pending = null;
}

// "v1.24.4 (1f63a91c)": frontend version, then the backend commit when it is known.
export function versionLabel(appVersion, backendCommit) {
  const commit = backendCommit && backendCommit !== "unknown" ? backendCommit : "";
  return commit ? `v${appVersion} (${commit})` : `v${appVersion}`;
}
